export class RefProtectionGel {
    id: number;
    code: string;
    libelle: string;
}
